// KWANKGM04250_借入申込希望書兼経営改善資金計画書 完了
import React, { memo } from 'react';
import HeadingM from '../../molecules/HeadingM';
import { modernization_funds_complete_disp_type } from '../../Const';

interface Props {
  disp_type: string | null;
}

const BusinessImprovementFinancingPlanExaminationCompleteBody: React.FC<Props> = ({
  disp_type,
}) => {
  // 見出しの文字列をセットする
  const setLabel = () => {
    switch (disp_type) {
      case modernization_funds_complete_disp_type.change_borrowing_application: // 借入申込変更の場合
        return '変更完了';
      default:
        return '申込完了';
    }
  };

  // 本文のJSXをセットする
  const setBody = () => {
    switch (disp_type) {
      case modernization_funds_complete_disp_type.change_borrowing_application:
        return <p className="p-lead">借入申込希望書兼経営改善資金計画書の変更を完了しました。</p>;

      case modernization_funds_complete_disp_type.pattern_1:
        return (
          <p className="p-lead">
            お客様のお申し込みを受け付けました。
            <br />
            現在、お申し込み内容を確認中です。確認完了後、ご登録のメールアドレスにメールを送信しますので、お待ち下さい。
          </p>
        );

      case modernization_funds_complete_disp_type.pattern_4:
        return <p className="p-lead">お客様のお申し込みを受け付けました。</p>;

      default:
        return (
          <p className="p-lead">
            お客様のお申し込みを受け付けました。
            <br />
            引き続き、「続けて借入申込書を入力」ボタンを押して入力を続けて下さい。
          </p>
        );
    }
  };

  return (
    <>
      <HeadingM label={setLabel()} />
      {setBody()}
    </>
  );
};

export default memo(BusinessImprovementFinancingPlanExaminationCompleteBody);
